module.exports = __webpack_public_path__ + "img/defaultPhone.b3a99768.svg";